export const spaceSizes = {
  s4: 4,
  s6: 6,
  s8: 8,
  s10: 10,
  s12: 12,
  s14: 14,
  s16: 16,
  s20: 20,
  s24: 24,
  s28: 28,
  s32: 32,
  s42: 42,
  s50: 50,
  s64: 64,
  s74: 74,
  s92: 92,
  s100: 100,
  s214: 214,
  s300: 300,
  sInfinity: '100%',
} as const;